import { useFormik } from 'formik';
import React from 'react'
import { useAppDispatch, useAppSelector } from '../../../State/Store';
import { TextField, Button, CircularProgress, Stack, Alert } from '@mui/material';
import { fetchUserProfile, sendLoginSignupOtp, signIn } from '../../../State/AuthSlice';
import { useNavigate } from 'react-router-dom';
type Props ={
  setLocalError: React.Dispatch<React.SetStateAction<string | null>>;
  setSuccessMessage: React.Dispatch<React.SetStateAction<string | null>>;
}
export const LoginForm:React.FC<Props> = ({setLocalError,setSuccessMessage}) => {
  const dispatch = useAppDispatch()
  const {auth} = useAppSelector(store=>store)
  const navigate = useNavigate()
  const formik = useFormik({
    initialValues: {
      email: "",
      otp: "",
    },
    onSubmit:async (values) => {
      //submit form data
     try {
       setLocalError(null);
       await dispatch(signIn(values)).unwrap();
      
      setSuccessMessage("Login Successfully, You will be redirected to home page")
     setTimeout(async() => {
      await dispatch(fetchUserProfile()).unwrap();
      navigate("/"); // Navigate after 1 second
    }, 1500); // 1000ms delay
     } catch (error:any) {
  
      setSuccessMessage(null)
      setLocalError(error)
     }
    },
  });
  const handleSentOtp =async () => {
   try {
    setLocalError(null)
    // The issue here is that the error is not caught completely in your try-catch and propagates as an so need to async await
   await dispatch(sendLoginSignupOtp({ email: formik.values.email,role:"ROLE_CUSTOMER",isSignup:false })).unwrap();
   setSuccessMessage("Otp sent successfully")
   } catch (error:any) {
   
    
      setLocalError(error)
   }
  };


 
  return (
    <div >
      
        <h1 className='text-center font-bold text-xl text-primary pb-8'>Login</h1>
        <form >
        <div className="space-y-5">
          <TextField
            fullWidth
            name="email"
            label="Email"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
          />
          {auth.otpSent && (
            <div className="space-y-2">
              <p className="font-medium text-sm opacity-60">
                Enter OTP Sent to Your Email
              </p>
              
              <TextField
                fullWidth
                name="otp"
                label="Otp"
                value={formik.values.otp}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.otp && Boolean(formik.errors.otp)}
                helperText={formik.touched.otp && formik.errors.otp}
              />
            </div>
          )}
         {!auth.otpSent? <Button
            onClick={handleSentOtp}
            fullWidth
            variant="contained"
            sx={{ py: "11px" }}
          >
           {auth.loading? <CircularProgress />:"send otp"}
            Sent otp
          </Button>: <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ py: "11px" }}
            onClick={(e) => { 
              e.preventDefault();
              formik.handleSubmit() }}
          >
            Login
          </Button>}
         
        </div>
      </form>
    </div>
  )
}
